import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditOrderEndpoint extends Endpoint {

  adaptValues({ordersNumber, order}) {
    return {
      "orders_number": ordersNumber,
      "delivery_site": order.delivery_site,
      "delivery_date": order.delivery_date,
      "purchase_orders_number": order.customers_order_number
    }
  }
}